"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @TODO: add the tests after useModelsMenuContext is added
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
// import { useModelsMenuContext } from 'providers/ModelsMenuProvider';
// import {
//   openMenuFirst,
//   toggleMenu,
//   toggleOverlay,
// } from 'components/hooks/useModelsMenuReducer';
const i18n_1 = require("@completeanatomy/i18n");
const ModelsPanelContent_1 = __importDefault(require("../ModelsPanelContent"));
const device_1 = require("@completeanatomy/device");
const models_1 = require("@completeanatomy/models");
const odr_1 = require("@completeanatomy/odr");
const react_dom_1 = require("react-dom");
const tabs = [
    (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.female),
    (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.male),
    (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.detailed),
];
var TabsEnum;
(function (TabsEnum) {
    TabsEnum[TabsEnum["Female"] = 0] = "Female";
    TabsEnum[TabsEnum["Male"] = 1] = "Male";
    TabsEnum[TabsEnum["Models"] = 2] = "Models";
})(TabsEnum || (exports.TabsEnum = TabsEnum = {}));
// eslint-disable-next-line max-lines-per-function
function ModelsPanel(props, ref) {
    const [tabCount, setTabCount] = (0, react_1.useState)(0);
    const [animationIsDone, setAnimationIsDone] = (0, ui_1.useToggleState)(false);
    const bridge = (0, bridge_1.useBridge)();
    const statedSelectedTab = (0, models_1.useSelectedModelsTab)();
    const models = (0, models_1.useModelsAccess)();
    const currentSelectedModel = (0, models_1.useSelectedModel)();
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(statedSelectedTab);
    const containerRef = (0, react_1.useRef)(null);
    const tabRef = (0, react_1.useRef)(null);
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { show: showOfflineSnackbar } = (0, odr_1.useOfflineSnackbars)();
    // const modelID = useDownloadingModelId();
    // const progress = useDownloadingModelProgress(modelID);
    // const isProgress = progress > 0;
    const onClose = (force) => {
        if (animationIsDone && force) {
            setTabCount(0);
            setTimeout(onClosePanel, 300);
        }
    };
    const onClosePanel = () => {
        var _a;
        /**
         * @todo Remove when model onboarding is connected into ReUI
         */
        // @ts-ignore
        (_a = window.showStartupHint) === null || _a === void 0 ? void 0 : _a.call(window);
        props.setIsOpen(false);
    };
    /**
     * Show outline when focus is programmatically moved to the first tab
     * Remove outline when user tabs away from first tab
     */
    const onTab = () => {
        if (tabRef === null || tabRef === void 0 ? void 0 : tabRef.current) {
            if (tabCount === 0) {
                tabRef.current.focus();
                tabRef.current.setAttribute('style', 'outline: #47cfcb solid 2px;');
            }
            else if (tabCount === 1) {
                tabRef.current.removeAttribute('style');
            }
        }
        setTabCount(tabCount + 1);
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        close: () => onClose(true),
    }));
    (0, ui_1.useKeyPress)({ key: 'Escape', action: () => onClose() });
    (0, ui_1.useKeyPress)({ key: 'Tab', action: () => onTab() });
    (0, ui_1.useOutsideClick)(containerRef, () => onClosePanel(), [], {
        active: true,
        stopPropagation: true,
    });
    const onSelectModel = ({ mask, type, isAvailable, isDetailed, identifier, }) => {
        var _a;
        if (isOffline && isDetailed && !isAvailable) {
            showOfflineSnackbar(odr_1.ODRSnackbars.OfflineModelSnackbar);
            return;
        }
        /**
         * When user selects item from models panel
         * Hide labels if selected region is different
         * Hide labels if sex is different
         */
        const differentRegion = (currentSelectedModel === null || currentSelectedModel === void 0 ? void 0 : currentSelectedModel.mask) !== mask;
        const differentModel = (currentSelectedModel === null || currentSelectedModel === void 0 ? void 0 : currentSelectedModel.type) !== type;
        if (differentRegion || differentModel) {
            /**
             * Calls clearAll from labelManager
             * And hides Cut Tools in the Main Menu Tool panel if selectedModel is detailed
             *
             * @todo Remove when tools are implemented
             */
            // @ts-ignore
            (_a = window.clearAllTools) === null || _a === void 0 ? void 0 : _a.call(window, { isDetailed });
        }
        // Pass the previous selected model and the model being selected
        if (typeof props.onSelectModelOnline === 'function') {
            props.onSelectModelOnline(currentSelectedModel, {
                identifier,
                mask,
                type,
                isDetailed,
            });
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.selectModelAndRegion({
            bodyRegionMask: mask,
            modelType: type,
            isOpenedFromInfobox: false,
        });
        setTimeout(() => {
            var _a;
            props.setIsOpen(false);
            // @ts-ignore
            (_a = window.showStartupHint) === null || _a === void 0 ? void 0 : _a.call(window);
        }, 200);
    };
    const onTabSelect = (i) => () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectModelsPanelTab(i);
        setSelectedTab(i);
    };
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { zIndex: 2, "data-e2e": 'ModelsPanel_Overlay' }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: props.isOpen, timeout: 300, onEntered: setAnimationIsDone, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ModelsPanel_CSSTransition', children: (0, jsx_runtime_1.jsx)(focus_trap_react_1.default, { active: true, focusTrapOptions: { initialFocus: false, allowOutsideClick: true }, "data-e2e": 'ModelsPanel_FocusTrap', children: (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, "data-e2e": 'ModelsPanel_Container', children: [(0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'ModelsPanel_Header', children: (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.models) }), (0, jsx_runtime_1.jsx)(Tabs, { "data-e2e": 'ModelsPanel_Tabs', children: tabs.map((tab, index) => ((0, jsx_runtime_1.jsx)(TabButton, { onClick: onTabSelect(index), "aria-selected": index === selectedTab, role: "tab", ref: index === 0 ? tabRef : null, "data-e2e": 'ModelsPanel_TabButton', children: tab }, index))) }), (0, jsx_runtime_1.jsx)(ModelsPanelContent_1.default, Object.assign({}, props, { models: models, onSelectModel: onSelectModel, selectedTab: selectedTab, className: "className", "data-e2e": 'ModelsPanel_ModelsPanelContent' })), (0, jsx_runtime_1.jsx)(Cross, { onClick: onClosePanel, "data-e2e": 'ModelsPanel_Cross' })] }) }) })] }), document.body);
}
exports.default = (0, react_1.forwardRef)(ModelsPanel);
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;

  z-index: 2;

  width: 100%;
  overflow: hidden;

  color: ${props => props.theme.modelsPanel.title};

  background: ${props => props.theme.background};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: 752px;
    border-radius: 8px;
    top: 16px;
    bottom: 16px;
    left: 16px;
  `)};

  &.enter {
    transform: translateX(-100%);
  }

  &.enter-active {
    transform: translateX(0);

    transition: transform 300ms linear;
  }

  &.exit {
    transform: translateX(0);
  }

  &.exit-active {
    transform: translateX(-100%);

    transition: transform 300ms linear;
  }
`;
const Header = styled_components_1.default.div `
  position: relative;

  padding-top: 0;

  font-size: 22px;
  line-height: 48px;

  text-align: center;

  background: ${props => props.theme.backgroundSecondary};

  ${ui_1.devicePortrait.mobileM((0, styled_components_1.css) `
    padding-top: 24px;
  `)};
  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    padding-top: 0;
  `)}
  ${ui_1.device.laptopS((0, styled_components_1.css) `
    font-size: 32px;
    line-height: 72px;
    font-weight: bold;

    text-align: left;

    background: ${props => props.theme.background};
    padding-left: 24px;
    border-radius: 8px;
  `)};
`;
const Cross = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.CloseButton) `
  position: absolute;

  top: 8px;
  right: 8px;

  width: 32px;
  height: 32px;

  border-radius: 4px;
  ${ui_1.devicePortrait.mobileM((0, styled_components_1.css) `
    top: 32px;
  `)};
  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    top: 8px;
  `)}
`);
const Tabs = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding: 16px 0;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    justify-content: flex-start;
    padding-left: 24px;
  `)};
`;
const TabButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.FlatButton) `
  margin: 0 12px;
  padding: 3px 6px 5px;

  &:first-child {
    margin-left: 28px;
  }

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    &:first-child {
      padding-left: 6px;
    }
  `)};

  color: ${props => props['aria-selected']
    ? props.theme.modelsPanel.title
    : props.theme.textSecondary};

  font-weight: ${props => (props['aria-selected'] ? 'bold' : 'normal')};
  font-family: inherit;

  text-transform: uppercase;

  background: ${props => props.theme.background};

  border-radius: 4px;
`);
